(ns frontend.view.modals.delete-confirmation.view
  (:require
   [common.localization :as loc]
   [reagent.core :as r]
   [ui.color :as c]
   [ui.components.input.checkbox :as checkbox]
   [ui.components.modal.view :as modal]))

(defonce modal-key :delete-confirmation-modal)

(defn view
  [{:keys [_shown? _close-modal! _props _topmost?]}]
  (let [confirmed? (r/atom false)
        toggle-confirm! (fn []
                          (reset! confirmed? (not @confirmed?)))]
    (fn [{:keys [shown? close-modal! props topmost?]}]
      (let [{:keys [body body-extra-note on-delete! lang-kw]} props
            lang-kw (or lang-kw :en)]
        [modal/view
         {:visible?      (and shown? topmost?)
          :hide!         close-modal!
          :backdrop      "static"
          :color         ::c/danger
          :close-button? true}
         (loc/tr :attention nil lang-kw)
         [:div
          {:class "py-4 flex flex-col gap-4"}
          [:p
           (if (string? body)
             [:strong
              {:class "font-bold"}
              body]
             body)]
          (when body-extra-note
            [:p body-extra-note])
          [:div
           [:label
            {:class "inline-flex gap-3 items-center cursor-pointer"}
            [checkbox/view
             {:value     @confirmed?
              :on-change toggle-confirm!}]
            [:span
             (loc/tr :i-understand-theres-no-undo-for-this nil lang-kw)]]]]
         [:<>
          [modal/left-cancel-only close-modal! nil]
          [modal/right-single-button
           ::c/danger
           (not @confirmed?)
           (fn [_]
             (on-delete!)
             (reset! confirmed? false)
             (close-modal!))
           (loc/tr :delete)
           nil]]]))))
